import React, { useCallback } from 'react';
import type { UserOption } from '@atlassian/jira-base-user-picker/src/types.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import UserPickerField from '../../common/ui/fields/base-fields/user-picker-field/index.tsx';
import type { PeopleFieldProps } from './types.tsx';
import { transformToUserOption } from './utils.tsx';

const PeopleField = (props: PeopleFieldProps) => {
	const {
		additionalData: { isMulti },
		autoCompleteUrl,
		selectedProject,
		...rest
	} = props;

	const projectKey = selectedProject?.projectKey;

	const fetchSuggestions = useCallback(
		async (query: string | null): Promise<UserOption[]> => {
			const autoCompleteResponse = await performGetRequest(
				`/rest/api/3/user/recommend?${new URLSearchParams({
					context: 'People',
					...(projectKey && { project: projectKey }),
					query: query ?? '',
				})}`,
			);

			return (autoCompleteResponse ?? []).map(transformToUserOption);
		},
		[projectKey],
	);

	return (
		<UserPickerField
			{...rest}
			isMulti={isMulti}
			autoCompleteUrl={autoCompleteUrl}
			onFetchSuggestions={fetchSuggestions}
		/>
	);
};

export default PeopleField;
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { mutatePeopleField, mapUserOptionOrOptionsToIds } from './utils';
